import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Typography,
} from "@mui/material";
import ModalClub from "./ModalClub";

const ListaClub = ({ club, Origen }) => {
  const [isAccordionExpanded, setIsAccordionExpanded] = React.useState(false);

  return (
    <React.Fragment>
      <Accordion
        className="Acordeon"
        expanded={isAccordionExpanded}
        onChange={(event, isExpanded) => setIsAccordionExpanded(isExpanded)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className="AcordeonSummary"
        >
          <Typography className="Titulo" sx={{ width: "75%" }}>
            {club.nombre}
          </Typography>
          <Divider
            orientation="vertical"
            sx={{ width: "auto", height: "auto", m: 1 }}
          />
        </AccordionSummary>
        <AccordionDetails className="AcordeonDetail ">
          <ModalClub
            club={club}
            Origen={Origen}
            onClose={() => setIsAccordionExpanded(false)}
          />
        </AccordionDetails>
      </Accordion>
    </React.Fragment>
  );
};

export default ListaClub;
